import { type LoaderFunctionArgs } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { getLinesByDayAndRange } from '#app/models.server/lines/index.ts'
import { getSectionById } from '#app/models.server/sections/index.js'
import SectionLayout from './SectionLayout'

export async function loader({ params }: LoaderFunctionArgs) {
  const { day, sectionId } = params
  if (!day) {
    throw new Error('Missing day')
  }
  const section = sectionId ? await getSectionById(sectionId) : null
  if (!section) {
    throw new Error('Section not found')
  }
  const lines = await getLinesByDayAndRange(day, section.start, section.end)

  return { section, lines }
}

export default function () {
  const { lines, section } = useLoaderData<typeof loader>()

  return <SectionLayout section={section} lines={lines} />
}
